const Style = ({ isMobile }) => `
  <style>
    .wrapper {
      padding: 40px 16px;
    }

    .eyebrow {
      text-align: center;
      width: 100%;
      display: inline-block;
    }

    .headline {
      margin: 12px 0;
      text-align: center;
    }

    .headline span {
      display: block;
    }

    p.description {
      line-height: 20px;
      ${
        isMobile
          ? 'text-align: left;'
          : `
          text-align: center;
          max-width: 740px;
          margin: 0 auto;
        `
      }
    }

    .disclaimer {
      text-align: center;
      width: 100%;
      display: inline-block;
      color: #8F9494;
    }

    ::slotted(.before-after-slider) {
      margin: 24px auto;
      ${isMobile ? 'width: 100%;' : 'width: 750px;'}
    }
  </style>`;

export default Style;
